import { useContext, useMemo } from 'react'
import NewsletterContext from '../contexts/Newsletter'

import withScreenSize from './withScreenSize'
import withEnv from './withEnv'
import {
  IAppLink,
} from '../types/layout'

const withAppLinks = () => {
  const {
    isSize,
  } = withScreenSize()
  const newsletterContext = useContext(NewsletterContext)
  const isBigScreen = isSize('medium')
  const {
    dev,
  } = withEnv()
  const allLinks: IAppLink[] = useMemo<IAppLink[]>(() => {

    const links: IAppLink[] = [{
      title: 'HOME',
      page: 'home',
      group: 'home',
      topbar: true,
    }, {
      divider: true,
      title: 'BOWIE',
      page: 'bowie',
      group: 'bowie',
      topbar: true,
    }, {
      title: '101010',
      page: 'threetens_home',
      group: 'threetens',
      topbar: true,
    }, {
      title: 'GODPIXEL',
      page: 'godpixel_home',
      group: 'godpixel',
      topbar: true,
    }, {
      title: 'GRAVEN',
      page: 'graven_home',
      group: 'graven',
      topbar: true,
    }, {
      title: 'SUBSCRIBE',
      handler: () => newsletterContext.open(),
      divider: true,
    }, {
      title: 'CONTACT',
      url: 'https://formlets.com/forms/GFDF91GPP8hoNzLq/',
    }, {
      title: 'IMPRESSUM',
      page: 'impressum'
    }]
    //.filter(l => !dev && l.dev ? false : true)

    return links

  }, [
    dev,
    newsletterContext.open,
  ])

  const topbarLinks = useMemo<IAppLink[]>(() => {
    if(!isBigScreen) return []
    return allLinks.filter(link => link.topbar ? true : false)
  }, [
    allLinks,
    isBigScreen,
  ])

  return {
    isBigScreen,
    allLinks,
    topbarLinks,
  }
}

export default withAppLinks

